var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStegLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12000_53822",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12000_53822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0423 37.0793C33.4822 35.1993 35.2422 39.2793 35.4022 42.0393C35.1622 46.3193 32.2822 48.9193 26.6823 48.9993C21.1223 49.0793 12.8423 42.2793 13.0023 31.2793C13.1623 20.2794 20.5623 10.2794 28.8823 3.3194C37.2022 -3.64059 26.6023 7.07938 25.0023 9.19938C23.4023 11.3194 16.9623 18.4394 17.8823 29.9593C18.5623 38.2393 25.6823 40.6393 26.7223 40.6393C29.6423 40.6393 30.9223 39.7993 30.9223 38.7993C31.0023 37.8393 30.6022 37.7593 30.0423 37.0793Z",
    fill: "#1170B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8817 35.279C27.4417 35.399 27.0417 32.799 27.1617 31.239C27.2817 29.679 29.9617 27.519 30.1617 26.679C30.3617 25.839 30.1217 24.959 30.1217 24.959C30.1217 24.959 31.8817 25.279 32.6017 26.359C33.3217 27.439 33.4417 29.039 32.5617 29.879C31.6417 30.719 30.6817 31.279 30.6817 32.359C30.6817 33.439 31.1617 35.239 31.8817 35.279Z",
    fill: "#EB3124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6023 25.2389C26.4023 23.8789 26.8423 21.3189 27.4423 19.8789C28.0423 18.4389 31.3223 17.2789 31.8023 16.5589C32.2823 15.8389 32.3223 14.9189 32.3223 14.9189C32.3223 14.9189 33.8823 15.7989 34.2023 17.0389C34.5223 18.2789 34.1223 19.8789 33.0023 20.3589C31.8823 20.8389 30.8023 21.0789 30.4423 22.1189C30.0423 23.1589 29.9223 24.9589 30.6023 25.2389Z",
    fill: "#EB3124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8025 15.319C28.6025 13.959 29.0425 11.399 29.6425 9.95901C30.2425 8.51901 33.5225 7.35902 34.0025 6.63902C34.4825 5.91902 34.5225 4.99902 34.5225 4.99902C34.5225 4.99902 36.0825 5.87903 36.4025 7.11903C36.7225 8.35902 36.3225 9.95902 35.2025 10.439C34.0825 10.919 33.0025 11.159 32.6425 12.199C32.2425 13.199 32.1625 15.039 32.8025 15.319Z",
    fill: "#EB3124"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStegLogo);
export default __webpack_public_path__ + "static/media/stegLogo.ed1d1208ab70a48928d0a061b70f4a2e.svg";
export { ForwardRef as ReactComponent };